import api from './api';

export interface Estimate2ListItem {
  id: number;
  prepared_at: string; // Data
  client: string; // Zamawiający
  object_name: string; // Nazwa obiektu
  total_value: number; // Wartość
  status: string; // Status
}

export const getEstimates2 = async (): Promise<Estimate2ListItem[]> => {
  const res = await api.get<Estimate2ListItem[]>('/estimates2');
  return res.data;
};


